/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import ForwardIcon from '@mui/icons-material/Forward';
import { addJobRequestData, getCSVColumnMapping } from 'src/services/countandorderServices';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import * as XLSX from 'xlsx';
// @ts-ignore
import Papa from "papaparse/papaparse.min.js";
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import _ from 'lodash';
import { Autocomplete, TextField } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface RequestDataProps {
    "jiraID":string;
    "requestName": string;
    "clientID": number;
    "dataAnalystUserID": number;
    "projectName": string;
    "projectTypeID": number;
    "jobTypeID": number;
    "source_NPI_FieldName": string;
    "source_FirstName_FieldName": string;
    "source_LastName_FieldName": string;
    "source_Address1_FieldName": string;
    "source_Address2_FieldName": string;
    "source_City_FieldName": string;
    "source_State_FieldName": string;
    "source_Zip_FieldName": string;
    "source_Phone_FieldName": string;
    "source_StateLicense_FieldName": string;
    "source_MENumber_FieldName": string;
    "source_DEANumber_FieldName": string;
    "provID_FieldName": string;
    "specID_FieldName": string;
    "nameParser_FullName_FieldName": string;
    "source_Email_FieldName": string;
    "source_Email2_FieldName": string;
    "nameParser_ParseHint": number;
    "suppress_Email_NotNull": number;
    "suppress_Email_SameHLD": number;
    "suppress_Phone_NotNull": number;
    "suppress_Phone_SameHLD": number;
    "suppress_Address_NotNull": number;
    "suppress_Address_SameHLD": number;
    "mailable_Rating": number;
    "emailSale_ContractType": string;
    "emailSale_ExpirationDate": string;
    "emailSale_RentalCount": number;
    "emailSale_TierToAppend": number;
    "userId": number;
}
interface PropsType {
    activeStep: number;
    onBackClick: () => void;
    selectedFiles: File[];
    onImportClick: () => void;
    requestData: RequestDataProps;
}


interface CSVMappingProps {
    label: string;
    value: string;
}

interface ApiResponse {
    status: number;
    data: {
        result: number;
        data: any;
    };
}

function CSVMapping({ activeStep, onBackClick, selectedFiles, requestData }: PropsType): JSX.Element {

    const navigate = useNavigate();

    const [csvMappingFields, setCSVMappingFields] = useState<CSVMappingProps[]>([])
    const [selectedFileFields, setSelectedFileFields] = useState<any>([])
    const [selectedAMPFields, setSelectedAMPFields] = useState<CSVMappingProps[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const clearAllNotifications = () : void=> {
        NotificationManager.listNotify.forEach((notification: any) =>
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          NotificationManager.remove(notification)
        );
      };
    useEffect(() => {
        getCSVColumnMapping()
            .then(
                (res: ApiResponse) => {
                    console.log("CSV Mapping==", res)
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const mapFileds: CSVMappingProps[] = []
                            Object.keys(res.data.data).map(
                                data => {
                                    mapFileds.push({
                                        value: data,
                                        label: res.data.data[data]
                                    })
                                }
                            )
                            setCSVMappingFields(mapFileds)
                        }
                    }
                }
            )
            .catch(
                error => console.log(error)
            )



        let csv: any;
        let data: any;

        const extension: any = selectedFiles[0]?.name?.split('.')?.pop()?.toLowerCase();

        const reader = new FileReader();

        if (selectedFiles.length > 0) {

            reader.onload = function (e: any) {
                if (extension == 'xls' || extension == 'xlsx') {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    // @ts-ignore
                    data = XLSX.utils.sheet_to_csv(ws, { header: 1, blankrows: false });
                    /* Update state */
                }
                else {
                    data = reader.result;
                }

                csv = Papa.parse(
                    data,
                    {
                        delimiter: ",",
                        download: false,
                        dynamicTyping: false,
                        encoding: "",
                        header: false,
                        preview: 0,
                        skipEmptyLines: false,
                        step: undefined,
                        worker: false,
                    }
                );

                const records = csv.data;
                setSelectedFileFields(records[0])

            }
        }
        if (extension == 'xls' || extension == 'xlsx') {
            reader.readAsBinaryString(selectedFiles[0])
        }
        else {
            reader.readAsText(selectedFiles[0]);
        }
    }, [])

    const handleAMPChange = (selectedObj: CSVMappingProps, fileFields: string): void => {

        console.log("selectedObj", selectedObj)
        // setSelectedAMPFields((prevSelectedAMPFields) => ({
        //     ...prevSelectedAMPFields,
        //     [fileFields]: event.target.value,
        //   }))
        // @ts-ignore
        setSelectedAMPFields((prevSelectedAMPFields) => {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [fileFields]: removed, ...rest } = prevSelectedAMPFields;
            return (selectedObj !== null && selectedObj.value !== "")
                ? { ...rest, [fileFields]: selectedObj.value }
                : rest;
        });
    }

    const handleImport = (): void => {
        const swappedObj: any = {};

        console.log("selectedAMPFields==1", selectedAMPFields)

        for (let key in selectedAMPFields) {
            if (selectedAMPFields.hasOwnProperty(key)) {
                // @ts-ignore
                swappedObj[selectedAMPFields[key]] = key;
            }
        }

        console.log("selectedAMPFields==2", swappedObj)


        if (!_.isEmpty(swappedObj)) {
            requestData.source_NPI_FieldName = swappedObj.Source_NPI_FieldName ? swappedObj.Source_NPI_FieldName : "";
            requestData.source_FirstName_FieldName = swappedObj.Source_FirstName_FieldName ? swappedObj.Source_FirstName_FieldName : "";
            requestData.source_LastName_FieldName = swappedObj.Source_LastName_FieldName ? swappedObj.Source_LastName_FieldName : "";
            requestData.source_Address1_FieldName = swappedObj.Source_Address1_FieldName ? swappedObj.Source_Address1_FieldName : "";
            requestData.source_Address2_FieldName = swappedObj.Source_Address2_FieldName ? swappedObj.Source_Address2_FieldName : "";
            requestData.source_City_FieldName = swappedObj.Source_City_FieldName ? swappedObj.Source_City_FieldName : "";
            requestData.source_State_FieldName = swappedObj.Source_State_FieldName ? swappedObj.Source_State_FieldName : "";
            requestData.source_Zip_FieldName = swappedObj.Source_Zip_FieldName ? swappedObj.Source_Zip_FieldName : "";
            requestData.source_Phone_FieldName = swappedObj.Source_Phone_FieldName ? swappedObj.Source_Phone_FieldName : "";
            requestData.source_StateLicense_FieldName = swappedObj.Source_StateLicense_FieldName ? swappedObj.Source_StateLicense_FieldName : "";
            requestData.source_MENumber_FieldName = swappedObj.Source_MENumber_FieldName ? swappedObj.Source_MENumber_FieldName : "";
            requestData.source_DEANumber_FieldName = swappedObj.Source_DEANumber_FieldName ? swappedObj.Source_DEANumber_FieldName : "";
            requestData.provID_FieldName = swappedObj.provID_FieldName ? swappedObj.provID_FieldName : "";
            requestData.specID_FieldName = swappedObj.specID_FieldName ? swappedObj.specID_FieldName : "";
            requestData.nameParser_FullName_FieldName = swappedObj.NameParser_FullName_FieldName ? swappedObj.NameParser_FullName_FieldName : "";
            // Check if nameParser_ParseHint is null or 0 and nameParser_FullName_FieldName has a value
            if ((!requestData?.nameParser_ParseHint || requestData.nameParser_ParseHint === 0) && requestData.nameParser_FullName_FieldName) {
                requestData.nameParser_ParseHint = 4;
            }
            console.log(requestData);
            const formData = new FormData();
            formData.append('file', selectedFiles[0]);
            //@ts-ignore
            formData.append("requestData", JSON.stringify(requestData))

            setIsLoading(true)
            addJobRequestData(formData)
                .then(
                    res => {                       
                        if (res.status === 200) {
                            clearAllNotifications();
                            if (res.data.result === 1) {
                                NotificationManager.success("Job request created successfully");                              
                                setTimeout(() => {
                                    navigate('/manage-jobs');
                                }, 500);
                            }
                            else {
                                NotificationManager.error("Unknown error occurred")
                            }
                        }
                    }
                )
                .catch(
                    error => console.log(error)
                )
                .finally(
                    () => setIsLoading(false)
                )
        } else {
            NotificationManager.error("Please select mapping fields")
        }

    }
    return (
        <React.Fragment>

            <div className='grid gap-5 grid-cols-3' style={{ marginBottom: '20px' }}>
                <div className='w-full relative text-16 font-semibold text-title'>Available CSV columns</div>
                <div className='w-full relative'></div>
                <div className='w-full relative text-16 font-semibold text-title'>AMP fields</div>
            </div>
            {
                selectedFileFields.map(
                    (fileFields: string, index: number) => {
                        return (
                            <div className='grid gap-5 grid-cols-3' style={{ marginBottom: '20px' }} key={index}>
                                <div className='w-full relative self-center truncate text-muted'>{fileFields}</div>
                                <div className='w-full relative self-center text-center'>
                                    <ForwardIcon sx={{ color: '#CBD1DC' }} />
                                </div>
                                <div className='w-full relative self-center'>
                                    <Box >
                                        <FormControl fullWidth>
                                            {/* @ts-ignore */}
                                            <Autocomplete
                                                disablePortal
                                                // disableClearable
                                                id="combo-box-demo"
                                                popupIcon={<KeyboardArrowDownIcon />}
                                                // open={openAutocomplete}
                                                // onOpen={() => setOpenAutocomplete(true)}
                                                // onClose={() => setOpenAutocomplete(false)}
                                                // onFocus={() => setOpenAutocomplete(true)}
                                                // @ts-ignore
                                                // value={getValueFromObject(ProjectTypes, field.value)}
                                                options={csvMappingFields}
                                                onChange={(event: any, newValue: any) => {
                                                    handleAMPChange(newValue, fileFields)
                                                }}
                                                // sx={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="Field" />}
                                            />

                                        </FormControl>
                                    </Box>
                                </div>
                            </div>
                        )
                    }
                )
            }

            <hr style={{ color: "#D9D9D9" }} />

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, justifyContent: 'flex-end', columnGap: '15px' }}>

                {/* <OutlineButton onClick={onBackClick} color='gray'>
                    Back
                </OutlineButton> */}
                <button className="btn btn-sm border-0 rounder-none bg-white normal-case shadow-none pl-0 hover:bg-white text-muted2 focus:shadow-md" onClick={onBackClick} disabled={isLoading}><span className="icon-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="#77869E"></rect><path d="M9 12L5.32547 8.70707C4.89151 8.31819 4.89151 7.68182 5.32547 7.29294L9 4" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>Back</button>
                {/* <Box sx={{ flex: '1 1 auto' }} /> */}

                <GradientButton type='button' onClick={handleImport} color='red' disabled={isLoading} >
                    {isLoading ? <span className="loading loading-spinner loading-xs text-white"></span> : 'Import'}
                </GradientButton>
            </Box>
        </React.Fragment>
    )
}

export default CSVMapping